"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetExtendedClientAllOf {
    static getAttributeTypeMap() {
        return GetExtendedClientAllOf.attributeTypeMap;
    }
}
GetExtendedClientAllOf.discriminator = undefined;
GetExtendedClientAllOf.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "GetExtendedClientAllOfAddress"
    }
];
exports.GetExtendedClientAllOf = GetExtendedClientAllOf;
//# sourceMappingURL=getExtendedClientAllOf.js.map